import {ReactElement} from "react";

export function RenderSetBudgetApproval(props: {variables: Record<string, unknown>}): ReactElement {
    const budgetYear = props.variables["budgetYear"];
    const approved = props.variables["approved"];

    return <div>
        <div>Budget Year: {budgetYear}</div>
        <div>Approved: {approved === true ? "Yes" : "No"}</div>
    </div>;
}

